import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import UserLogin from "./Components/Services/UserLogin";

import Download from "./Pages/Template/Download";
import PrivateRoute from "./Components/PrivateRoute";

import Database from "./Layouts/Database";
import ProductDBForm from "./Pages/Product/ProductDBForm";
import IngredientDBForm from "./Pages/Ingredient/IngredientDBForm";
import DisplayTable from "./Components/Services/userDB";
import Productitem from "./Pages/Product/Productitem";
import IngredientItem from "./Pages/Ingredient/IngredientItem";
import NotFoundPage from "./Components/Services/Notfound";
import ResetPassword from "./Components/Services/ResetPassword";
import { ThemeProvider } from "@mui/material/styles";
import darkTheme from "./Hooks/theme"; // Assuming your theme is in a file named theme.js
import { CssBaseline } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import IngredientDatabase from "./Pages/Ingredient/IngredientDatabase";
import ProductDatabase from "./Pages/Product/ProductDatabase";
import { ModalProvider } from "./Hooks/modalContext";
import Modal from "./Components/Services/DefaultModal";

import Counter from "./Components/Counter";

import { useDispatch, useSelector } from "react-redux";
import { refreshToken } from "./store/Reducer/AuthReducer";

import "react-toastify/dist/ReactToastify.css"; // Ensure this is included
import Loader from "./Components/Services/Loader";
import DeclarationEdit from "./Components/Database/IngredientForm/DeclarationEdit";

function App() {
  // const { role } = useAuth();
  const [initialRoute, setInitialRoute] = useState('');

  const { role, isLoading } = useSelector((state) => {
    return state.auth;
  });

  const dispatch = useDispatch();




  useEffect(() => {


    // const refreshToken = async () => {
    //   try {
    //     const res = await axios.post(
    //       `${process.env.REACT_APP_BASE_URI}/auth/refresh`,
    //       {},
    //       { withCredentials: true }
    //     );

    //     

    //     if (res.status === 200) {
    //
    //     }
    //   } catch (error) {
    //     console.error("Failed to refresh access token:", error);
    //   }
    // };

    //Checks user session after refresh


    // const checkSession = async () => {
    //   try {
    //     await dispatch(userSession());
    //     setIsSessionResolve(true);
    //   } catch (error) {
    //     console.error("Session check failed:", error);
    //     toast.error("Session expired. Redirecting to login...");
    //     Navigate("/"); // Redirect to login on failure
    //   }
    // }
    // checkSession();

    //fetch last route stored in localstorage
    const lastRoute = localStorage.getItem("lastroute");
    if (lastRoute) {
      setInitialRoute(lastRoute);
    }

    //refresh token call after every 1 min
    const refreshTokenCall = async () => {
      // let attempts = 0;
      // const maxAttempts = 3;

      // while (attempts < maxAttempts) {
      try {
        const data = await dispatch(refreshToken({})).unwrap();
        return data; // Exit the function if successful
      } catch (error) {
        // attempts++;
        console.error("Token refresh failed:", error);

        const errorMessage = typeof error === "string" ? error : error?.message;

        if (errorMessage === "User Role Mismatch/Changed") {
          toast.error("User Role Mismatch/Changed", { toastId: "session-expired" })
          setTimeout(() => (<Navigate to='/' replace />), 2000);
          return;
        }

        // Handle unauthorized error (401)
        if (errorMessage === "Session expired. Please log in again.") {
          console.warn("Unauthorized! Redirecting to login...");
          if (!toast.isActive("session-expired")) {
            toast.error("Session expired. Redirecting to login...", { toastId: "session-expired" });
          }
          setTimeout(() => (<Navigate to='/' replace />), 2000);
          return;
        }

        if (errorMessage === "User details not found") {
          if (!toast.isActive("session-expired")) {
            toast.error("User details not found", { toastId: "session-expired" })
          }
          setTimeout(() => (<Navigate to='/' replace />), 2000);
          return;
        }

        if (errorMessage === "Please Login to Continue") {
          if (!toast.isActive("session-expired")) {
            toast.error("Please Login to Continue", { toastId: "session-expired" })
          }
          setTimeout(() => (<Navigate to='/' replace />), 2000);
          return;
        }

        if (errorMessage === "Network error. Unable to refresh token.") {
          if (!toast.isActive("session-expired")) {
            toast.error("Network error. Unable to refresh token", { toastId: "session-expired" })
          }
        }

        if (errorMessage === "An unexpected error occurred. Try again.") {
          if (!toast.isActive("session-expired")) {
            toast.error("An unexpected error occurred. Try again.", { toastId: "session-expired" })
          }
          setTimeout(() => (<Navigate to='/' replace />), 2000);
          return;
        }

        // Retry on network errors (no response from server)
        // if (error?.message === "Network error. Unable to refresh token.") {
        //   const delay = Math.pow(2, attempts) * 1000; // Exponential backoff

        //   await new Promise((resolve) => setTimeout(resolve, delay));
        //   continue;
        // }

        // // Other errors → Stop retrying
        // break;
      }
      // }

      // console.error("Max retry attempts reached. Redirecting to login.");
      if (!toast.isActive("session-expired")) {
        toast.error("Session expired. Redirecting to login...", { toastId: "session-expired" });
        setTimeout(() => (<Navigate to='/' replace />), 2000);
      }
      // localStorage.removeItem("lastroute")
    };


    const interval = setInterval(refreshTokenCall, 120000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [dispatch]);


  if (isLoading) {
    return <Loader />;
  }


  return (
    <Router>
      <ToastContainer
        theme="dark" // Change to 'light' if preferred
      />
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />

        <ModalProvider>
          <Routes>

            <Route path="/" element={<UserLogin />} />
            <Route path="/counter" element={<Counter />} />
     
       
           
            {/* Nested Routing of /database route */}
            <Route
              path="/database"
              element={
                <PrivateRoute component={Database} requiredRole={role} />
              }
            >
              {/* index route */}
              <Route index element={<Navigate to="products" replace />} />
              <Route
                path="ingredient"
                element={
                  <PrivateRoute
                    component={IngredientDatabase}
                    requiredRole={role}
                  />
                }
              />
              <Route
                path="products"
                element={
                  <PrivateRoute
                    component={ProductDatabase}
                    requiredRole={role}
                  />
                }
              />
              <Route
                path="displaytable"
                element={
                  <PrivateRoute component={DisplayTable} requiredRole={role} />
                }
              />
            </Route>
            <Route
              path="/productdbform"
              element={
                <PrivateRoute component={ProductDBForm} requiredRole={role} />
              }
            />
            <Route
              path="/download"
              element={
                <PrivateRoute component={Download} requiredRole={role} />
              }
            />
            <Route
              path="/ingredientdb"
              element={
                <PrivateRoute
                  component={IngredientDBForm}
                  requiredRole={role}
                />
              }
            />
            <Route
              path="/productitem/:product_id"
              element={
                <PrivateRoute component={Productitem} requiredRole={role} />
              }
            />
            <Route
              path="/ingredient/:ing_item_code"
              element={
                <PrivateRoute component={IngredientItem} requiredRole={role} />
              }
            />
            <Route
              path="/ingredient/:ing_item_code/:rm_code"
              element={
                <PrivateRoute component={DeclarationEdit} requiredRole={role} />
              }
            />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>

          <Modal />
        </ModalProvider>


      </ThemeProvider>
    </Router>
  );
}

export default App;
